import { Link } from 'react-router-dom';

const sections = [
  {
    title: 'Um þjónustuna',
    body: 'Sundkortið er stafrænt sundkort sem gefur handhafa aðgang að sundlaugum sem taka þátt í kerfinu. Þjónustan er rekin af Sundkortið ehf. og er ætluð einstaklingum sem vilja nýta sér sundlaugar á þægilegan og öruggan hátt.',
  },
  {
    title: 'Kaup og greiðsla',
    body: 'Öll kaup fara fram í gegnum öruggar greiðslugáttir. Sundkort eru gefin út í tafarlausu eftir staðfesta greiðslu. Verð eru þau sem koma fram á vefnum á kaupstundinni og eru tilgreind með VSK.',
  },
  {
    title: 'Notkun kortsins',
    body: 'Hvert sundkort inniheldur ákveðinn fjölda heimsókna. Þegar QR-kóðinn er skannaður í sundlaug dregst ein heimsókn af kortinu. Heimsóknin er óafturkræf eftir skannun. Eitt kort gildir eingöngu fyrir einn einstakling í hvert sinn.',
  },
  {
    title: 'Gildistími',
    body: 'Sundkort gilda í 12 mánuði frá kaupdegi nema annað sé tekið fram. Ónotaðar heimsóknir falla niður við lok gildistíma og eru ekki endurgreiddar.',
  },
  {
    title: 'Endurgreiðslur',
    body: 'Ef tæknilegt bilun á sér stað við skannun eða heimsókn er skráð á rangan hátt getur notandi haft samband við þjónustuver til að fá leiðréttingu. Endurgreiðsla vegna ónotaðra heimsókna er ekki möguleg nema sérstakar aðstæður séu fyrir hendi samkvæmt mati þjónustuveitanda.',
  },
  {
    title: 'Notendaskilyrði',
    body: 'Notandi verður að vera að lágmarki 18 ára til að búa til aðgang og kaupa sundkort. Notanda er óheimilt að deila lykilorði sínu eða QR-kóða með öðrum. Misnotkun leiðir til lokunar á aðgangi án endurgreiðslu.',
  },
  {
    title: 'Breytingar á skilmálum',
    body: 'Sundkortið ehf. áskilur sér rétt til að breyta þessum skilmálum. Notendur verða upplýstir um verulegar breytingar með tölvupósti. Áframhaldandi notkun þjónustunnar eftir tilkynningu um breytingar telst samþykki á nýjum skilmálum.',
  },
  {
    title: 'Tengiliðaupplýsingar',
    body: 'Spurningar varðandi skilmála eða þjónustuna í heild má senda á netfangið: skilmalar@sundkortid.is',
  },
];

export function SkilmalarPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-8 py-4">
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo-no-text.png" alt="" className="h-9 w-auto" />
            <span className="text-xl font-title font-bold text-primary-800 tracking-wide">
              Sundkortið
            </span>
          </Link>
          <nav className="flex items-center gap-5">
            <Link
              to="/login"
              className="text-sm font-medium text-gray-500 hover:text-primary-700 transition-colors"
            >
              Innskráning
            </Link>
          </nav>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-8 pt-20 pb-32">
        <p className="text-xs font-semibold tracking-[0.25em] uppercase text-primary-400 mb-4">
          Lagaleg skjöl
        </p>
        <h1 className="text-4xl md:text-5xl font-title font-bold text-primary-900 mb-4">
          Skilmálar
        </h1>
        <p className="text-sm text-gray-400 mb-14">
          Uppfært {new Date().toLocaleDateString('is-IS', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>

        <div className="space-y-10">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-xl font-title font-semibold text-primary-900 mb-3">
                {s.title}
              </h2>
              <p className="text-gray-500 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-50 border-t border-gray-100 py-12">
        <div className="max-w-7xl mx-auto px-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src="/logo-no-text.png" alt="" className="h-6 w-auto opacity-30" />
            <span className="text-sm text-gray-400">
              &copy; {new Date().getFullYear()} Sundkortið
            </span>
          </div>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400">
            <a href="tel:6956771" className="hover:text-gray-600 transition-colors">695 6771</a>
            <a href="mailto:info@seifur.is" className="hover:text-gray-600 transition-colors">info@seifur.is</a>
            <Link to="/skilmalar" className="hover:text-gray-600 transition-colors">Skilmálar</Link>
            <Link to="/personuvernd" className="hover:text-gray-600 transition-colors">Persónuvernd</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
